var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0083",
    d: "M10.783 5.233c-2.546.471-4.671 2.46-5.456 5.117a6.3 6.3 0 0 0-.184 1.907c.017 1.449.321 2.619.969 3.673l.385.639l4.217-2.64v5.357h2.572v-5.284l4.26 2.395s1.071-1.8.986-1.872c-.022-.022-1.505-.94-3.292-2.032L12 10.496l-2.19 1.358q-1.13.737-2.327 1.359c-.103 0-.124-.27-.09-1.097c.034-.943.09-1.2.39-1.856a4.586 4.586 0 0 1 7.787-1.08a5.34 5.34 0 0 1 1.003 2.233c.064.33.128.613.141.621l1.068.656l1.037.635l.034-.926c.047-1.269-.129-2.1-.69-3.292a6.3 6.3 0 0 0-2.31-2.743a7.2 7.2 0 0 0-5.066-1.131z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomi);
export default __webpack_public_path__ + "static/media/tomi.db649b486c4be0dafcefaf56d7edcb48.svg";
export { ForwardRef as ReactComponent };